/** Extract a user-facing error message from an Axios-style API error. */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  const err = error as { response?: { data?: { error?: string; message?: string } } };
  return err?.response?.data?.error || err?.response?.data?.message || fallback;
}

/** True when the API returned 403 Forbidden. */
export function isForbiddenError(error: unknown): boolean {
  const err = error as { response?: { status?: number } };
  return err?.response?.status === 403;
}
